import { ChatStore } from "@/stores/ChatStore";
import { ExtensionMiddleTierToolResponse } from "@/types";

type ToolResult = {
  sources?: Array<{ chunk_id: string; title: string; chunk: string }>;
  action?: string;
  broker_info?: any;
  claim_status_info?: any;
};

export default function onReceivedExtensionMiddleTierToolResponse(toolResponse: ExtensionMiddleTierToolResponse) {
  const result: ToolResult = JSON.parse(toolResponse.tool_result);
  console.log("Tool result:", result);

  // Handle broker validation request
  if (result.action === "request_broker_validation") {
    console.log("[ToolResponse] Opening broker validation dialog");
    ChatStore.getState().setBrokerValidationDialogOpen(true);
    return;
  }

  // Handle claim status request
  if (result.action === "request_claim_status") {
    console.log("[ToolResponse] Opening claim status dialog");
    ChatStore.getState().setClaimStatusDialogOpen(true);
    return;
  }

  // Handle broker info display
  if (result.broker_info) {
    console.log("[ToolResponse] Setting broker info:", result.broker_info);
    ChatStore.getState().setBrokerInfo(result.broker_info);
    return;
  }

  // Handle claim status info display
  if (result.claim_status_info) {
    console.log("[ToolResponse] Setting claim status info:", result.claim_status_info);
    ChatStore.getState().setClaimStatusInfo(result.claim_status_info);
    return;
  }

  // Handle grounding sources/files
  if (result.sources) {
    const groundingFiles = result.sources.map(x => ({
      id: x.chunk_id,
      name: x.title,
      content: x.chunk
    }));
    ChatStore.getState().updateLastMessageGroundingFiles(groundingFiles);
  }
}

